import { instance } from '@/services/cc/rdpInstance';

export const listAlertEventLogs = (param) => instance.post('alert/event/list', param);
export const verifyMail = (param) => instance.post('user/verifyMail', param);
export const verifyIm = (param) => instance.post('user/verifyIm', param);
